





















import { createComponent } from "@vue/composition-api";
import {
  ZastosowanieCategory,
  Zastosowanie,
  zastosowanieCategoryResource,
} from "@megarax/client/src/resources/plm";

import ZastosowanieForm from "./ZastosowanieForm.vue";

interface Props {
  value: Zastosowanie[];
}

export default createComponent<Props>({
  components: { ZastosowanieForm },
  props: {
    value: { required: true, type: Array },
  },
  setup(props, ctx) {
    function addZastosowanie(category: ZastosowanieCategory) {
      if (
        props.value.filter((unit) => unit.category.id === category.id).length !=
        0
      ) {
        ctx.root.$notify.warning("Istnieje już zastosowanie w tej kategorii.");
        return;
      }

      const zastosowanie = new Zastosowanie();
      zastosowanie.category = category;
      zastosowanie.properties = {};

      props.value.push(zastosowanie);
    }

    function removeZastosowanie(zastosowanie: Zastosowanie) {
      const index = props.value.findIndex(
        (z) => z.category === zastosowanie.category,
      );
      props.value.splice(index, 1);
    }

    return {
      zastosowanieCategoryResource,
      addZastosowanie,
      removeZastosowanie,
    };
  },
});
